import { Key, useEffect, useState } from "react";
import {
  Box,
  Card,
  IconButton,
  Typography,
  styled,
  useMediaQuery,
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import styles from "./SliderServices.module.scss";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import {
  apiRequest,
  authService,
  catchErrorMessageHandler,
} from "../../infrastructure/backendService";
import ToastAttention from "../common/toast/toastAttention";
import { CommonButton } from "../common/StyledComponents/StyledFields";
import CommonDonationPopup from "../home/CommonDonationPopup";
import { CMS_BASE_URL } from "../../config/apiUrl";
import ToastError from "../common/toast/toastError";
import { isNil } from "lodash";
import ErrorPopup from "../common/ErrorPopup";
import constants from "../../config/constants.json";
import { RoutingURLs, SubRoutingURLs } from "../common/RoutingURLs";

const StyledIconsButton = styled(IconButton)`
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,
    rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
  padding: 4px;
`;

const SliderServices = (): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);
  const [homeservicesList, sethomeServicesList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width: 600px)"); // Adjust the breakpoint as needed
  const role = sessionStorage.getItem("selectedRole");

  const previousSlide = (): any => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? homeservicesList.length - 1 : prevIndex - 1
    );
  };

  const nextSlide = (): any => {
    if (isMobile) {
      setCurrentIndex((prevIndex) =>
        prevIndex === homeservicesList.length - 1 ? 0 : prevIndex + 1
      );
    } else {
      setCurrentIndex((prevIndex) => {
        const newIndex = prevIndex + 3;
        return newIndex >= homeservicesList.length ? 0 : newIndex;
      });
    }
  };

  const visibleData = isMobile
    ? [homeservicesList[currentIndex]]
    : homeservicesList.slice(currentIndex, currentIndex + 3).filter(Boolean);

  const handleClick = (buttonType: string, event_id?: string) => {
    if (buttonType.toLowerCase() === "annadana") {
      if (authService.isAuthenticated()) {
        navigate(`${RoutingURLs.home}?donationID=${event_id}`);
      } else {
        navigate(`${RoutingURLs.home}?donationID=${event_id}`);
      }
    } else {
      if (!authService.isAuthenticated()) {
        toast.custom(
          <ErrorPopup
            headerTitle="Attention"
            showMessage="Please Login"
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      } else {
        if (constants.showDashBoardForRoles.includes(role || "")) {
          let routePath =
            buttonType.toLowerCase() === "pooja booking"
              ? SubRoutingURLs.POOJA_BOOKING
              : SubRoutingURLs.HALL_RENTAL;
          navigate(`/managerDashboard/devoteeservice/${routePath}`);
        } else {
          let routePath =
            buttonType.toLowerCase() === "pooja booking"
              ? SubRoutingURLs.POOJA_BOOKING_REQUEST
              : SubRoutingURLs.EVENT_HALL_BOOKING_REQUEST;
          navigate(`/devoteebooking/${routePath}`);
        }
      }
    }
  };

  useEffect(() => {
    gethomeServices();
    // console.log('getUpComingEvents called useEffect');
  }, []);

  const gethomeServices = (): void => {
    apiRequest({
      basePath: `${CMS_BASE_URL}`,
      method: "GET",
      endpoint: "/wp-json/wp/v2/home-services",
    })
      .then((res) => {
        // Set up the upcoming events list
        const acfList = res.data.map((item: any) => item.acf);
        sethomeServicesList(acfList);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const isFirstPage = currentIndex === 0;
  const isLastPage = isMobile
    ? currentIndex === homeservicesList.length - 1
    : currentIndex + 3 >= homeservicesList.length;

  return (
    <Box className={styles.servicesMainContainer}>
      <Typography className={styles.servicesTitle}>Services</Typography>
      <Box className={styles.conatainer}>
        <StyledIconsButton
          className={`${styles.carouselButton} ${
            isFirstPage ? styles.disabled : styles.active
          }`}
          onClick={previousSlide}
          disabled={isFirstPage}
        >
          <ChevronLeftIcon />
        </StyledIconsButton>

        <Box className={styles.carousel}>
          {visibleData.map((info: any, index: any) => (
            <Card
              className={`${styles.service_card} ${
                index === 0 ? styles.active : ""
              }`}
              key={info && info.id && <>{info.id}</>}
            >
              <Box className={styles.Image}>
                {/* <img src={info.image_url} alt={""} /> */}
                {info && info.image_url && <img src={info.image_url} alt="" />}
              </Box>
              <Box className={styles.titleButton}>
                <Typography className={styles.headingStyles}>
                  {info && info.title && <>{info.title}</>}
                  <br />
                  {info &&
                    info.sponsor_url &&
                    info.sponsor_url
                      .split(",")
                      .map((link: any, index: number) => {
                        const isLastItem = index === link.length - 2;
                        if (index % 2 === 0) {
                          const displayText = link.trim();
                          const urlIndex = index + 1;
                          const url = info.sponsor_url
                            .split(",")
                            [urlIndex]?.trim();
                          if (url) {
                            return (
                              <span key={index}>
                                {index !== 0 && "| " }
                                <a
                                  href={url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ color: "blue", fontSize: "12px" }}
                                >
                                  {displayText}
                                </a>
                                {" "}
                              </span>
                            );
                          }
                        }
                        return null;
                      })}
                </Typography>

                <CommonButton
                  onClick={() => {
                    handleClick(info.title, info?.event_id);
                  }}
                  className={styles.buttonStyles}
                >
                  {/* {info.button_action} */}
                  {info && info.button_action && <>{info.button_action}</>}
                </CommonButton>
              </Box>
            </Card>
          ))}
        </Box>

        <StyledIconsButton
          className={`${styles.carouselButton} ${
            isLastPage ? styles.disabled : styles.active
          }`}
          onClick={nextSlide}
          disabled={isLastPage}
        >
          <ChevronRightIcon />
        </StyledIconsButton>
      </Box>
      <CommonDonationPopup isOpen={isOpen} setIsOpen={setIsOpen} />
    </Box>
  );
};

export default SliderServices;
